import React from "react";
import NewPasswordForm from "./LeftPannel";
import InfoPanel from "../components/RightPannel";
const NewPassword = () => {
  return (
    <InfoPanel parent="newpassword">
      <NewPasswordForm />
    </InfoPanel>
  );
};

export default NewPassword;
